import { render, staticRenderFns } from "./products-list.vue?vue&type=template&id=f1d47ede&scoped=true&"
import script from "./products-list.vue?vue&type=script&lang=js&"
export * from "./products-list.vue?vue&type=script&lang=js&"
import style0 from "./products-list.vue?vue&type=style&index=0&id=f1d47ede&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1d47ede",
  null
  
)

export default component.exports